import React from 'react'
import { SECTION_IDS } from '../../constants'
import { ComponentSeparator, ExposeSectionTitleWrapper } from '../../style'
import { Typography } from 'react-components'
import { useTranslation } from '../../../../hooks/locale'
import PulsatingDots from '../../pulsating-dots'

interface LazyEntitySectionProps {
    isLoading?: boolean
    error?: Error | null
    pastDelay?: boolean
}

const LazyEntitySectionLoading: React.FC<LazyEntitySectionProps> = () => {
    const { t } = useTranslation()
    return (
        <section id={SECTION_IDS.ENTITY_SECTION_ID}>
            <ExposeSectionTitleWrapper>
                <Typography variant="h6" fontWeight="semiBold" element="h2">
                    {t('entitySection.title')}
                </Typography>
            </ExposeSectionTitleWrapper>
            <PulsatingDots />
            <ComponentSeparator />
        </section>
    )
}

export default LazyEntitySectionLoading
